<mat-dialog-content class="dialog-content">
  <app-patient-whiteboard
    #whiteboardComponent
    [preloadedImages]="(diagramImages$ | async)"
    [uploadOnSave]="uploadOnSave"
    (save)="saveAndClose()"
    (delete)="checkDeleteDiagram()">
  </app-patient-whiteboard>
</mat-dialog-content>
